import React from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import ColorPicker from '../../common/color-picker';
import StyledColorBlock from '../../common/styled-color-block';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

import { chartActions, getChart } from '../../../core/chart';
import { getSelectedGeneration } from '../../../core/generations';
import { cellsActions, getSelectedCell } from '../../../core/cells';
import { setColorMode, getColorMode } from '../../../core/ui';
import { colorToString } from '../../../core/utils';

import { _Field, _Label, _Heading, _TextButton } from '../styled-sidebar';
import theme from '../../../styles/theme';

import { range } from 'lodash';

import { StyledScrollable, StyledMargin } from '../../common/styled-base';


class ColorMenu extends React.Component {

  handleUpdate = (key, value, isColor) => {
    const { cell, generation, colorMode, batchUpdateCells } = this.props;

    const n = Math.pow(2, generation.index);

    let cells = [];
    if (colorMode === 'individual') {
      cells = [{ ascendancy: cell.ascendancy }];
    } else if (colorMode === 'chart') {
      cells = range(0, 1024).map(i => ({ ascendancy: i + 1 }));
    } else if (colorMode === 'generation') {
      cells = range(0, n).map(i => ({ ascendancy: n + i }));
    } else if (colorMode === 'generation-quarter' && n >= 4) {
      cells = range(0, n / 4).map(i => ({ ascendancy: cell.ascendancy + i }));
    } else if (colorMode === 'generation-half' && n >= 2) {
      cells = range(0, n / 2).map(i => ({ ascendancy: cell.ascendancy + i }));
    } else if (colorMode === 'generation-alternating') {
      cells = range(0, n / 2).map(i => ({ ascendancy: n + (i * 2) + cell.ascendancy % 2 }));
    } else if (colorMode === 'ancestors') {
      const queue = [cell.ascendancy];
      while (queue.length) {
        const ascendancy = queue.pop();
        cells.push({ ascendancy })
        if (ascendancy <= 512) {
          queue.push(ascendancy * 2, ascendancy * 2 + 1);
        }
      }
    }
    const color = (value && isColor) ? colorToString(value) : value;
    const updates = cells.map(cell => ({ ...cell, [key]: color }));
    batchUpdateCells(updates);
  }

  render() {
    const {
      cell,
      chart,
      colorMode,
      setStrokeColor,
      setColorMode,
    } = this.props;

    const colorModes = ['individual', 'generation', 'generation-alternating', 'generation-quarter', 'generation-half', 'ancestors', 'chart'];

    return (
      <StyledScrollable padding='15px'>

        <_Field>
          <_Label>Color Mode</_Label>
          <SelectField
            className="kt-select"
            value={colorMode}
            labelStyle={{ color: 'rgba(255,255,255,0.8)' }}
            selectedMenuItemStyle={{ color: theme.primary }}
            onChange={(e, index, value) => setColorMode(value)}
          >
            {colorModes.map(mode => <MenuItem value={mode} primaryText={mode} key={mode} />)}
          </SelectField>
        </_Field>

        <_Field>
          <_Label>Text Color</_Label>
          <StyledMargin marginTop="5px">
            <ColorPicker color={cell.textColor} onChange={(color) => this.handleUpdate('textColor', color, true)}>
              <StyledColorBlock color={cell.textColor} />
            </ColorPicker>
          </StyledMargin>
        </_Field>

        <_Field>
          <_Label>Background Color</_Label>
          <StyledMargin marginTop="5px">
            <ColorPicker color={cell.background} onChange={(color) => this.handleUpdate('background', color, true)}>
              <StyledColorBlock color={cell.background} />
            </ColorPicker>
          </StyledMargin>
        </_Field>

        <_Field>
          <_Label>
            Band Color
            (<_TextButton onClick={() => this.handleUpdate('bandColor', null, true)}>
              remove
            </_TextButton>)
          </_Label>
          <StyledMargin marginTop="5px">
            <ColorPicker color={cell.bandColor || '#fff'} onChange={(color) => this.handleUpdate('bandColor', color, true)}>
              <StyledColorBlock color={cell.bandColor} />
            </ColorPicker>
          </StyledMargin>
        </_Field>

        <_Field>
          <_Label>Line Color</_Label>
          <StyledMargin marginTop="5px">
            <ColorPicker color={chart.strokeColor} onChange={color => setStrokeColor(color.hex)}>
              <StyledColorBlock color={chart.strokeColor} />
            </ColorPicker>
          </StyledMargin>
        </_Field>

        <_Field>
          <_Label>Text Inverted</_Label>
          <StyledMargin marginTop="5px">
            <SelectField
              className="kt-select"
              value={cell.inverted}
              labelStyle={{ color: 'rgba(255,255,255,0.8)' }}
              selectedMenuItemStyle={{ color: theme.primary }}
              onChange={(e, index, value) => this.handleUpdate('inverted', value)}
            >
              <MenuItem value={false} primaryText="No" />
              <MenuItem value={true} primaryText="Yes" />
            </SelectField>
          </StyledMargin>
        </_Field>

      </StyledScrollable>
    )
  }
}

const mapStateToProps = createSelector(
  getChart,
  getSelectedGeneration,
  getSelectedCell,
  getColorMode,
  (chart, generation, cell, colorMode) => ({
    chart,
    generation,
    cell,
    colorMode,
  })
)

const mapDispatchToProps = Object.assign({ setColorMode }, chartActions, cellsActions)

export default connect(mapStateToProps, mapDispatchToProps)(ColorMenu);


// WEBPACK FOOTER //
// ./src/components/menu/color-menu/index.js